goog.provide('el8.ptdata.ptImmunizations');

goog.require('el8.ptdata.model.PatientItemSet');
goog.require('el8.data.physicians');
goog.require('el8.data.vaccines');
goog.require('el8.model.base');
goog.require('el8.template.ptdata.ptImmunizations');

el8.ptdata.ptImmunizations = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makePatientItem();

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        if (spec.vaccine) {
            spec.vaccine_id = el8.data.vaccines.create(spec.vaccine).getId();
        }
        this.parent.populate.call(this, spec);
    };
    _class.addIntProperty('vaccineId', true);
    /** For saving new vaccines **/
    _class.addStringProperty('manualVaccineName', true); // not directly stored on server
    /** For saving new physicians **/
    _class.addStringProperty('administeredBy', true); // not directly stored on server
    _class.addStringProperty('orderedBy', true); // not directly stored on server

    // These are new fields for users who want to submit immunizations to a registry
    _class.addStringProperty('allowedSharing', true);
    _class.addStringProperty('selectImmunizationRegistry', true);
    _class.addStringProperty('priorityPopulation', true);
    // these fields appear when a record is to be sent to a registry - a constrained list
    _class.addStringProperty('selectVISHandout', true);
    _class.addStringProperty('selectManufacturerName', true);
    _class.addStringProperty('selectQtyUnits', true);

    // This is a new field which will indicate whether an immunization was submitted
    _class.addIntProperty('submissionId', true);
    _class.addStringProperty('submission', true);

    _class.addIntProperty('administeringPhysicianId', true);
    _class.addIntProperty('orderingPhysicianId', true);
    _class.addDateTime('administeredDate', true);
    _class.addDate('expirationDate', true);
    _class.addStringProperty('qty', true); // float
    _class.addStringProperty('qtyUnits', true);
    _class.addStringProperty('doseInSeries', true); // float
    _class.addStringProperty('lotNumber', true);
    _class.addStringProperty('manufacturerName', true);
    _class.addStringProperty('ndcCode', true);
    _class.addStringProperty('method', true);
    _class.addStringProperty('site', true);
    _class.addStringProperty('reason', true);
    _class.addStringProperty('vis', true);
    _class.addStringProperty('description', true); //where manualVaccineName is sent back by the server
    _class.addStringProperty('notes', true);
    _class.addStringProperty('publicityCode', true);
    _class.addStringProperty('vfcEligibility', true);
    _class.addStringProperty('fundingSource', true);
    _class.addStringProperty('infoSource', true);
    _class.addStringProperty('patientConsent', true);

    // the specific packaged med selected
    // the backend model does not have this concept
    // this is only used to transmit the selected med
    // so we can populate the praticevaccincepreference (which understands packaged med)
    _class.addIntProperty('packagedMedId', true);

    /**
     * Custom asSoyMap method
     */
    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        delete mapped['manualVaccineName'];
        delete mapped['vaccineId'];
        delete mapped['administeredBy'];
        delete mapped['orderedBy'];
        mapped['vaccine'] = this.getVaccine().asSoyMap();

        mapped['submissionId'] = this.rawData.submission && this.rawData.submission.id;
        mapped['submission'] = this.rawData.submission;

        return mapped;
    };

    /**
     *  HELPER METHODS
     */
    _class.prototype.getVaccine = function() {
        return el8.data.vaccines.getById(this.getVaccineId());
    };
    _class.prototype.getVaccineName = function() {
        var vaccine = this.getVaccine();
        return vaccine ? vaccine.getName() : '';
    };
    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.ptImmunizations.noteSummary(this.asSoyMap()).el8_unescape();
    };
    _class.prototype.getAdministeringPhysicianName = function() {
        if (!this.getAdministeringPhysicianId()) { return null; }
        var physician = el8.data.physicians.getById(this.getAdministeringPhysicianId());
        return physician ? physician.getFullName() : '';
    };
    _class.prototype.getOrderingPhysicianName = function() {
        if (!this.getOrderingPhysicianId()) { return null; }
        var physician = el8.data.physicians.getById(this.getOrderingPhysicianId());
        return physician ? physician.getFullName() : '';
    };

    return new el8.ptdata.model.PatientItemSet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('ptImmunizations'); },
        saveFn: function(item, successCbFn) {
            el8.appservice.notifier.notify('Patient immunization being saved...');
            $.el8_ajax({
                url: el8.service.urls.get('ptImmunizations', [item]),
                type: 'POST',
                async: false,
                data: JSON.stringify(item.asMap(true)),
                success: function(data) {
                    if (item.getId()) {
                        el8.ptdata.ptImmunizations.updateItemId(item, data.item.id);
                    }
                    item.populate(data.item);
                    if (successCbFn) { successCbFn(item); }
                    el8.appservice.notifier.notify('Patient immunization saved.');
                }
            });
        },
        deleteFn: function(item, successCbFn) {
            el8.appservice.notifier.notify('Patient immunization being deleted...');
            $.el8_ajax({
                url: el8.service.urls.get('ptImmunizations', [item]),
                type: 'DELETE',
                success: function(data) {
                    el8.appservice.notifier.notify('Patient immunization deleted.');
                    if (successCbFn) { successCbFn(item); }
                }
            });
        }
    });

})();
